import { defineChain } from 'viem'

export const tcgVerse = defineChain({
  id: 2400,
  name: 'TCG Verse',
  nativeCurrency: { name: 'Oasys', symbol: 'OAS', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://rpc.tcgverse.xyz'],
    },
  },
  blockExplorers: {
    default: {
      name: 'TCG Verse-Mainnet explorer',
      url: 'https://explorer.tcgverse.xyz',
      apiUrl: 'https://explorer.tcgverse.xyz/api',
    },
  },
  testnet: false,
})
